/**
 * Returns true on truthy values and some falsy values
 * Permitted falsy values are: 0, -0, false
 * @param val
 * @returns
 */
export const hasValue = (
  val:
    | string
    | { label: string; value: string | number | boolean }
    | null
    | undefined
) => {
  return val
    ? typeof val === "string"
      ? !!val
      : val.value !== "" && val.value !== null && val.value !== undefined
    : false;
};

/**
 * Returns the value if it is valid, otherwise null.
 * Handles both single values and arrays (for isMulti select).
 * For arrays: returns the array if non-empty, otherwise null.
 * For single values: uses hasValue to check validity.
 */
export const hasValidValue = (val: any) => {
  if (Array.isArray(val)) return val.length > 0 ? val : null;
  return hasValue(val) ? val : null;
};
